import React from 'react';

interface BatteryIconProps {
    pct: number;
}

/** Battery indicator — pct is 0-100 */
const BatteryIcon: React.FC<BatteryIconProps> = ({ pct }) => {
    const color = pct >= 60 ? '#28a745' : pct >= 30 ? '#ffa000' : '#dc3545';
    const label = pct >= 60 ? 'bra' : pct >= 30 ? 'lågt' : 'kritiskt';
    const fillWidth = Math.max(0, Math.min(100, pct));
    return (
        <span title={`Batteri: ${pct} % (${label})`} style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', cursor: 'default' }}>
            <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                <span style={{
                    display: 'inline-block', width: '24px', height: '11px',
                    border: `1.5px solid ${color}`, borderRadius: '2px',
                    position: 'relative', overflow: 'hidden',
                }}>
                    <span style={{
                        display: 'block', height: '100%',
                        width: `${fillWidth}%`,
                        backgroundColor: color,
                        transition: 'width 0.3s',
                    }} />
                </span>
                <span style={{
                    display: 'inline-block', width: '2px', height: '5px',
                    backgroundColor: color, borderRadius: '0 1px 1px 0',
                }} />
            </span>
            <span style={{ fontSize: '12px', color, fontWeight: 'bold' }}>{pct}%</span>
        </span>
    );
};

export default BatteryIcon;
